import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import AboutRelayPreview from './AboutRelayPreview';

@Component({
  selector: 'about-relay-preview-react',
  templateUrl: './about-relay-preview-react-container.component.html',
  styleUrls: ['./about-relay-preview-react-container.component.scss'],
  standalone: true,
})
export class AboutRelayPreviewReactContainerComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @Input() showHamburger: boolean = true;
  @Input() color: string;
  reactWrapperId: string;
  root: Root = null;

  constructor() {}

  ngOnInit() {
    this.reactWrapperId = 'about-relay-preview';
  }

  protected getRootDomNode() {
    const node = document.getElementById(this.reactWrapperId);
    return node;
  }

  ngOnDestroy(): void {
    this.root?.unmount();
  }

  ngOnChanges(): any {
    this.render();
  }

  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(AboutRelayPreview, {
          showMenu: this.showHamburger,
          color: this.color,
        }),
      );
    }
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }
}
